import {
  DividerOrientation,
  DividerSpacing,
  DividerThickness,
  DividerTone,
} from "./Divider.types";

export const DIVIDER_ORIENTATION_CLASSES: Record<DividerOrientation, string> = {
  horizontal: "w-full",
  vertical: "self-stretch",
};

export const DIVIDER_SPACING_CLASSES: Record<
  DividerOrientation,
  Record<DividerSpacing, string>
> = {
  horizontal: {
    none: "",
    sm: "my-3",
    md: "my-5",
    lg: "my-7",
  },
  vertical: {
    none: "",
    sm: "mx-3",
    md: "mx-5",
    lg: "mx-7",
  },
};

export const DIVIDER_THICKNESS_CLASSES: Record<
  DividerOrientation,
  Record<DividerThickness, string>
> = {
  horizontal: {
    sm: "h-px",
    md: "h-0.5",
  },
  vertical: {
    sm: "w-px",
    md: "w-0.5",
  },
};

export const DIVIDER_TONE_CLASSES: Record<DividerTone, string> = {
  default: "bg-[#C4CAD8]",
  subtle: "bg-[#EFF0F4]",
  strong: "bg-[#AEB6C6]",
};
